import {lazy} from 'react';

export const InjectSVGLazy = lazy(() => import(/* webpackChunkName: "injectSVG" */ '.'));
